import { useLanguageContext } from "../../../../context/LanguageContext";
import AccessCommander2NConfigsPage from "../../../../pages/integrations/acces_commanders_2n_configs/index/AccessCommander2NConfigsPage";
import { useAccessCommander2NConfigsRouteValidator } from "../../../validators/integrations/accessCommander2N/AccessCommander2NConfigsRouteValidator";
import { RouteConfig } from "../../RouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useAccessCommander2NConfigsRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/integration/access_commander")
    .setLabel(translate("eva.main.entities.access_commander_2n_config"))
    .setValidator(useAccessCommander2NConfigsRouteValidator())
    .setPage(<AccessCommander2NConfigsPage />);
}

export default useAccessCommander2NConfigsRouteConfig;
